// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__zAd8c","pageNumber":"style_pageNumber__OmHcM","pageActive":"style_pageActive__0i0sa"};